export default {
  getInsights(state) {
    return state.insights;
  },
  getFilteredInsights(state) {
    return state.filteredInsights;
  },
};
